import { render, staticRenderFns } from "./PlantType.html?vue&type=template&id=66d9cbdb&scoped=true&external"
import script from "./PlantType.vue?vue&type=script&lang=js"
export * from "./PlantType.vue?vue&type=script&lang=js"
import style0 from "./PlantType.scss?vue&type=style&index=0&id=66d9cbdb&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d9cbdb",
  null
  
)

export default component.exports